<template>
  <v-container>
     <v-layout fluid>
       <v-flex xs12>
         <v-card>
            <v-card-title class="primary">
              <v-layout class="justify-space-around">
                <v-flex><h4 class="white--text">Compras</h4></v-flex>
               <v-flex>
                 <v-btn fab dark class="yellow" @click="cambiaredit" v-if="edit">
                <v-icon>edit</v-icon>
              </v-btn>
               </v-flex>
              </v-layout>


            </v-card-title>
           <v-card-text>
              <v-form>
                 <v-layout row class="justify-space-around" wrap>
                    <v-flex xs6 sm3>
                      <v-menu>
                         <v-text-field
                          name="fecha_factura"
                          slot="activator"
                          label="Fecha Factura"
                          prepend-icon="date_range"
                          :value="compra.fecha_facturacion"
                          :disabled="edit"

                      ></v-text-field>
                      <v-date-picker
                        v-model="compra.fecha_facturacion"
                        locale="es"
                      >

                      </v-date-picker>
                      </v-menu>

                    </v-flex>
                   <v-flex xs6 sm3>
                      <v-menu>
                         <v-text-field
                           name="fecha_ingreso"
                          slot="activator"
                          label="Fecha Ingreso"
                          prepend-icon="date_range"
                          :value="compra.fecha_ingreso"
                           :disabled="edit"
                      ></v-text-field>
                      <v-date-picker
                        v-model="compra.fecha_ingreso"
                        locale="es"
                      >

                      </v-date-picker>
                      </v-menu>

                    </v-flex>
                   <v-flex sm3 mr-2>
                     <v-text-field
                       required
                       :name="documento"
                       label="No.Documento"
                       v-model="compra.numerodocumento"
                       :disabled="edit"
                     >

                     </v-text-field>
                   </v-flex>
                   <v-flex>
                     <v-text-field
                       required label="Serie" name='serie'
                       v-model="compra.serie"
                       :disabled="edit"
                     ></v-text-field>
                   </v-flex>
                   <v-flex xs12 sm3>
                      <v-select
                        :disabled="edit"
                        name="proveedores"
                        v-bind:items="proveedores"
                        item-text="nombre"
                        item-value="id"
                        v-model="compra.proveedor"
                        label="Proveedor"
                        autocomplete
                      ></v-select>
                   </v-flex>
                    <v-flex xs12 sm3>
                     <v-text-field name="cantidad"
                                   label="Cantidad"
                                   v-model="compra.cantidad"
                                   :disabled="edit"
                     ></v-text-field>
                   </v-flex>
                   <v-flex xs12 sm3>
                     <v-text-field name="cantidad2"
                                   label="total calculado"
                                   v-model="compra.totalc"
                                   :disabled="true"
                     ></v-text-field>
                   </v-flex>
                    <v-flex xs9 sm3 style="display: flex">
                       <v-checkbox label="Pagada" v-model="compra.pagada" @change="cambio(compra.pagada)"></v-checkbox>
                      <v-checkbox label="Crédito" v-model="compra.credito" @change="cambio2(compra.credito)"></v-checkbox>
                   </v-flex>

                  </v-layout>

              </v-form>
           </v-card-text>
           <v-card-actions class="justify-space-between ">
             <v-btn class="ma-2 primary" dark v-if="!compra.id" @click="crearCompra(compra)">Guardar</v-btn>
             <v-btn class="ma-2 primary" v-if="compra.id" dark @click="actualizarcompra(compra)"
                    :disabled="edit" >Modificar</v-btn>
             <v-btn class="ma-2 red" dark @click="regresar">Cancelar</v-btn>
              <v-btn fab dark small class="success" @click.native.stop="actualizardialog(true)" v-if="compra.id">
                  <v-icon dark>add_shopping_cart</v-icon>
                </v-btn>
             <v-dialog
               v-model="dialogo"
               fullscreen

             >
               <template v-slot:activator="{ on }">

               </template>
               <v-card>
                 <v-card-title class="indigo">
                   <v-flex><h4 class="white--text">Linea Compra</h4></v-flex>
                 </v-card-title>
                 <v-card-text>
                   <v-layout class="justify-space-between wrap">
                     <v-flex xs12>
                       <v-select
                        :disabled="!edit"
                        name="Producto"
                        :search-input.sync="sproducto"
                        v-bind:items="productos"
                        item-text="producto"
                        item-value="id"
                        v-model="lineacompra.producto"
                        label="Producto:"
                        @input="cambiarprecio(lineacompra.producto)"
                        autocomplete
                      ></v-select>
                     </v-flex>
                     <v-flex xs12>
                        <v-text-field name="cantidad"
                                   label="Cantidad"
                                   v-model="lineacompra.cantidad"
                     ></v-text-field>
                     </v-flex>
                     <v-flex xs12>
                        <v-text-field name="Precio"
                                   label="Precio"
                                   v-model="lineacompra.precio"
                                   hidden
                     ></v-text-field>
                     </v-flex>
                     <v-flex xs12>
                        <v-text-field name="Precio"
                                   label="Precio Anterior"
                                   v-model="lineacompra.precio_compra"
                                   :disabled="true"
                                   hidden
                     ></v-text-field>
                     </v-flex>
                     <v-flex xs12>
                        <v-select
                        :disabled="!edit"
                        name="Presentacion"
                        v-bind:items="presentaciones"
                        item-text="presentacion"
                        item-value="id"
                        v-model="lineacompra.presentacion"
                        label="Presentación:"
                        autocomplete
                      ></v-select>
                     </v-flex>
                   </v-layout>

                 </v-card-text>
                 <v-card-action>
                   <v-btn class="ma-2 primary" dark  @click="crearLineaCompra(lineacompra)">Guardar</v-btn>
                   <v-btn class="ma-2 red" dark @click="actualizardialog(false)">Cancelar</v-btn>
                 </v-card-action>
               </v-card>
             </v-dialog>

           </v-card-actions>
         </v-card>
       </v-flex>
     </v-layout>
    <v-layout>
      <v-data-table
      v-bind:headers="headers"
      :items="compra.detallescompratemporal"
      hide-actions
      class="elevation-3"
    >
    <template slot="items" slot-scope="props">
      <td><v-btn icon class="red--text text--darken-2" @click="eliminar(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn></td>
      <td class="text-xs-right">{{ props.item.producto_name }}</td>
      <td class="text-xs-right">{{ props.item.cantidad }}</td>
      <td class="text-xs-right"></td>
      <td class="text-xs-right">{{ props.item.subtotal }}</td>
      <td class="text-xs-right">{{ props.item.presentacion_producto }}</td>
    </template>
  </v-data-table>
    </v-layout>
  </v-container>

</template>
<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    created: function () {
      this.$store.dispatch('getproveedores')
      this.$store.dispatch('getpresentaciones')
      if (this.compra.id) {
        this.$store.commit('seteditcompra', true)
        this.$store.commit('setcompralinea', this.compra.id)
      }
    },
    data () {
      return {
        fecha: null,
        fechaingreso: null,
        serietemp: '',
        sproducto: '',
        headers: [
          {text: '', value: ''},
          {text: 'Producto:', value: 'producto_name'},
          {text: 'Cantidad:', value: 'cantidad'},
          {text: 'Precio:', value: 'precio'},
          {text: 'Sub Total:', value: 'subtotal'},
          {text: 'Presentacion:', value: 'presentacion'}
        ]
      }
    },
    methods: {
      cambiaredit: function () {
        this.$store.commit('seteditcompra', !this.edit)
      },
      filtrar: function (item, queryText, itemText) {
        return item
      },
      ...mapActions(['crearCompra', 'actualizarcompra', 'crearLineaCompra']),
      regresar: function () {
        this.$store.commit('setcompra', [])
        this.$store.commit('seteditcompra', false)
        this.$router.push('/compratemporal')
      },
      cambio: function (dato) {
        if (dato) {
          this.$store.commit('setcredito', false)
        } else {
          this.$store.commit('setcredito', true)
        }
      },
      cambio2: function (dato) {
        if (dato) {
          this.$store.commit('setPagada', false)
        } else {
          this.$store.commit('setPagada', true)
        }
      },
      cambiarprecio: function (store) {
        let producto = this.productos.find(producto => producto.id === store)
        this.$store.commit('setpreciocompra', producto)
      },
      searchproductos () {
        this.$store.dispatch('buscarproductos', {producto: this.sproducto})
      },
      eliminar (linea) {
        let r = confirm(' esta seguro que desea eliminar ' + linea.producto_name)
        if (r === true) {
          this.$store.dispatch('eliminarlineacompra', linea)
        }
      },
      actualizardialog (payload) {
        this.$store.commit('actualizardialog', payload)
        if (!payload) {
          this.$store.commit('limpiarlineacompra', {presentacion: 7})
        }
      }
    },
    computed: {
      ...mapGetters({
        compra: 'getCompra',
        proveedores: 'getProveedores',
        edit: 'getEditCompra',
        productos: 'productos',
        lineacompra: 'getLineaCompra',
        presentaciones: 'getListadoPresentaciones',
        dialogo: 'dialogo'
      }),
      ...mapMutations([
        'setSerie',
        'seteditcompra'
      ]),
      serie: {
        set: function (e) {
          this.$store.commit('setSerie', e)
        },
        get: function () {
          return this.compra.serie
        }
      }
    },
    watch: {
      sproducto: function (dato) {
        this.$store.dispatch('buscarproductos', {producto: dato})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ComprasAdd.vue?2355b89e